import React from "react";
import { LocationIcon, PhoneIcon, MailIcon } from "./Icons";

const PrivacyPolicyModal = ({ open, onClose, heading }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div
        className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 overflow-y-auto relative"
        style={{ maxHeight: "70vh", minHeight: "320px" }}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-red-600 text-2xl font-bold"
          aria-label="Close"
        >
          &times;
        </button>
        <div
          className="overflow-y-auto"
          style={{ maxHeight: "60vh", scrollbarWidth: "none" }}
        >
          <h2 className="text-xl font-bold mb-4 text-red-700 flex items-center">
            <svg
              className="w-6 h-6 mr-2 text-red-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 11.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 2C7.03 2 3 6.03 3 11c0 5.25 7.5 11 9 11s9-5.75 9-11c0-4.97-4.03-9-9-9z"
              />
            </svg>
            {heading}
          </h2>
          {heading === "Privacy Policy" && (
            <>
              {" "}
              <p className="mb-4 text-gray-700 text-sm">
                At Amdavad Post, we respect your privacy and are committed to
                protecting your personal information. This Privacy Policy
                outlines our practices concerning the collection, use, and
                safeguarding of data belonging to our readers, subscribers, and
                website visitors.
              </p>
              <ol className="space-y-3 text-gray-700 text-sm">
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 01-8 0M12 3v4m0 0a4 4 0 01-4 4m4-4a4 4 0 014 4m-4 4v4m0 0a4 4 0 01-4 4m4-4a4 4 0 014 4" />
                    </svg>
                    Types of Information We Collect
                  </span>
                  <ul className="list-disc ml-7">
                    <li><span className="font-semibold">Personal Information:</span> We collect details you voluntarily provide (such as name, email address, and phone number) when you contact us, subscribe to our publications, or place an advertisement.</li>
                    <li><span className="font-semibold">Non-Personal Information:</span> We may automatically collect non-personal data, such as your browser type, device details, and website usage patterns, when you visit our website.</li>
                  </ul>
                </li>
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-6a2 2 0 012-2h2a2 2 0 012 2v6m-6 0h6" />
                    </svg>
                    Use of Your Information
                  </span>
                  <ul className="list-disc ml-7">
                    <li>To deliver news updates, newsletters, and other relevant communications.</li>
                    <li>To enhance our website, content, and reader services.</li>
                    <li>To respond to your inquiries, feedback, or complaints.</li>
                    <li>For advertising and promotional activities, conduct only with your explicit consent.</li>
                  </ul>
                </li>
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a5 5 0 00-10 0v2M5 9h14v10a2 2 0 01-2 2H7a2 2 0 01-2-2V9z" />
                    </svg>
                    Data Sharing and Disclosure
                  </span>
                  <p>We do not sell or rent your personal information to third parties. We may, however, share your data with trusted third-party service providers (e.g., email or web hosting services) strictly for operational purposes required to deliver our services.</p>
                </li>
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="3" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.4 15a1.65 1.65 0 01.33 1.82A8 8 0 013.27 16.82a1.65 1.65 0 01.33-1.82" />
                    </svg>
                    Cookies and Tracking Technologies
                  </span>
                  <p>Our website, www.amdavadpost.in, may use cookies and similar technologies to improve your browsing experience. You have the option to manage or disable cookies through your browser settings.</p>
                </li>
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <rect width="20" height="14" x="2" y="5" rx="2" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11h8M8 15h8" />
                    </svg>
                    Data Security
                  </span>
                  <p>We implement reasonable security measures to protect your personal information from unauthorized access, disclosure, alteration, and misuse.</p>
                </li>
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2a2 2 0 00-2-2H5a2 2 0 00-2 2v2zm0-14v2a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2z" />
                    </svg>
                    Data Retention
                  </span>
                  <p>We will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy and to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our policies.</p>
                </li>
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 20h9" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4h9" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v16" />
                    </svg>
                    Third-Party Websites
                  </span>
                  <p>Our website may contain links to other websites that are not operated by us. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services. We strongly advise you to review the Privacy Policy of every site you visit.</p>
                </li>
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14s1.5 2 4 2 4-2 4-2" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 9h.01M15 9h.01" />
                    </svg>
                    Children's Privacy
                  </span>
                  <p>Our services are not intended for individuals under the age of 13. We do not knowingly collect personally identifiable information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately.</p>
                </li>
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-green-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12h.01M12 12h.01M9 12h.01M12 17h.01M12 7h.01" />
                    </svg>
                    Your Data Rights and Choices
                  </span>
                  <ul className="list-disc ml-7">
                    <li>You have the right to request access to, correction of, or deletion of your personal data at any time.</li>
                    <li>You have the right to unsubscribe from our communications at any time.</li>
                  </ul>
                </li>
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3" />
                      <circle cx="12" cy="12" r="10" />
                    </svg>
                    Updates to This Privacy Policy
                  </span>
                  <p>We reserve the right to update this Privacy Policy periodically. Any modifications will be posted on this page, and the "Last Updated" date will be revised accordingly.</p>
                </li>
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <rect width="20" height="14" x="2" y="5" rx="2" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11h8M8 15h8" />
                    </svg>
                    Governing Law
                  </span>
                  <p>This Privacy Policy is governed by and construed in accordance with the laws of India.</p>
                </li>
                <li>
                  <span className="font-bold flex items-center mb-1">
                    <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12v4m0 0v4m0-4h4m-4 0h-4" />
                    </svg>
                    Contact Us
                  </span>
                  <ul className="list-none ml-7 space-y-1">
                    <li className="flex items-center">
                      <MailIcon />
                      <span>Email: <a href="mailto:amdavadpost.in@gmail.com" className="text-blue-700 underline">amdavadpost.in@gmail.com</a></span>
                    </li>
                    <li className="flex items-center">
                      <PhoneIcon />
                      <span>Phone/WhatsApp: <a href="tel:+919737299098" className="text-blue-700 underline">+91 97372 99098</a></span>
                    </li>
                    <li className="flex items-center">
                      <LocationIcon />
                      <span>Office Address: Safal Sumel-8, D-314, Ajit Mill Cross Road, Rakhiyal Road, Ahmedabad – 380023, Gujarat</span>
                    </li>
                  </ul>
                </li>
              </ol>
              <div className="mt-4 text-center text-base font-bold text-red-700">
                Amdavad Post – Truth in Your Hand.
              </div>
            </>
          )}
          {heading === "Terms of Use" && (
            <div className="text-gray-700 text-sm">
              <p className="mb-4">
                These are the Terms of Use for Amdavad Post. Please read them carefully before using our website or services.
              </p>
              <ul className="list-disc ml-6 space-y-2">
                <li>By accessing or using our website, you agree to be bound by these terms.</li>
                <li>Content is for informational purposes only and may change without notice.</li>
                <li>Unauthorized use of the site may give rise to a claim for damages and/or be a criminal offense.</li>
                <li>All trademarks reproduced in this website are acknowledged.</li>
                <li>We reserve the right to modify these terms at any time.</li>
              </ul>
              <div className="mt-4 text-center text-base font-bold text-red-700">
                Amdavad Post – Truth in Your Hand.
              </div>
            </div>
          )}
          {heading === "Cookie Policy" && (
            <div className="text-gray-700 text-sm">
              <p className="mb-4">
                This Cookie Policy explains how Amdavad Post uses cookies and similar technologies to recognize you when you visit our website.
              </p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Cookies are small data files placed on your device.</li>
                <li>We use cookies to improve your browsing experience and analyze site traffic.</li>
                <li>You can control cookies through your browser settings.</li>
                <li>By using our site, you consent to our use of cookies.</li>
              </ul>
              <div className="mt-4 text-center text-base font-bold text-red-700">
                Amdavad Post – Truth in Your Hand.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
